import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { toast } from "react-toastify";
import FormDrawer from "src/components/Form/FormDrawer";
import { dripiconlist } from "src/helpers/iconList";
import { useAppSelector } from "src/store";
import { getAgreementTypes, getSectors } from "src/store/system/saga";
import { AgreementTypeDto, SectorDto } from "src/store/system/type";
import { createAgreementSaga } from "src/store/agreements/saga";
import * as Yup from "yup";

const AgreementsCreateForm = ({
  onHide,
  open,
  onSuccessClick,
}: {
  onSuccessClick: (message: string) => void;
  onHide: () => void;
  open: boolean;
}) => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const languages = useAppSelector((s) => s.language.languages);
  const [types, setTypes] = useState<AgreementTypeDto[]>([]);
  useEffect(() => {
    open &&
      dispatch(
        getAgreementTypes({
          payload: {
            onSuccess: (m, p) => setTypes(p),
            onError: () => {},
          },
        })
      );
  }, [dispatch, open]);
  return (
    <React.Fragment>
      <FormDrawer
        drawerProps={{
          isOpen: open,
          onHide: onHide,
          title: t("Agreements.CreateFormTitle").toString(),
        }}
        onHide={onHide}
        loader
        initialValues={{
          Id: "",
          Description: "",
          Title: "",
          IsActive: "",
          PolicyTypeId: "",
          Translates: languages.map((x) => {
            return {
              LanguageId: x.EnumId,
              Title: "",
              Description: "",
            };
          }),
        }}
        onSubmit={(values) => {
          dispatch(
            createAgreementSaga({
              payload: {
                onSuccess: (message, payload) => {
                  onHide();
                  onSuccessClick(message);
                },
                onError: (message) => {
                  toast.error(message, {
                    theme: "colored",
                  });
                },
              },
              body: values,
            })
          );
        }}
        validationSchema={Yup.object().shape({
          Title: Yup.string().required(t("Validation.Required").toString()),
          Description: Yup.string().required(
            t("Validation.Required").toString()
          ),
          Icon: Yup.string().required(t("Validation.Required").toString()),
          SectorId: Yup.string().required(t("Validation.Required").toString()),
          Translates: Yup.array(
            Yup.object({
              Title: Yup.string().required(t("Validation.Required").toString()),
              Description: Yup.string().required(
                t("Validation.Required").toString()
              ),
            })
          ),
        })}
        multilanguageinputs={[
          {
            field: "Title",
            label: t("Agreements.Title").toString(),
          },
          {
            field: "Description",
            label: t("Agreements.Description").toString(),
            isEditor: true,
          },
        ]}
        inputs={[
          {
            field: "PolicyTypeId",
            label: t("Agreements.Type").toString(),
            type: "select",
            lookup: {
              labelKey: "Name",
              valueKey: "EnumId",
              options: types,
            },
          },

          {
            field: "IsActive",
            label: t("Agreements.IsActive").toString(),
            type: "switch",
          },
        ]}
      />
    </React.Fragment>
  );
};
export default AgreementsCreateForm;
